export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const SET_FAB_ACTIONS = 'SET_FAB_ACTIONS';
export const SET_FAB_ACTIONS_BY_KEY = 'SET_FAB_ACTIONS_BY_KEY';
export const UPDATE_FAB_STYLES = 'UPDATE_FAB_STYLES';
